import React, { useEffect, useRef, useState } from 'react';
import { sqAxiosStore } from '@/core/core.stores';
import { useFlux } from '@/core/hooks/useFlux.hook';

interface LoadingSpinnerProps {
  top?: boolean;
  noToolName?: boolean;
}

/**
 * This component encapsulates the "loading indicator" spinner
 */
export const LoadingSpinner: React.FunctionComponent<LoadingSpinnerProps> = ({ top, noToolName }) => {
  const { pendingRequests } = useFlux(sqAxiosStore);
  const nRequests = useRef(pendingRequests);
  const spinnerTimeout = useRef<number>(undefined);
  const [progress, setProgress] = useState(0);
  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    if (nRequests.current > pendingRequests) {
      if (pendingRequests === 0) {
        setProgress(100);
      } else {
        setProgress((1 / pendingRequests) * 100);
      }
    } else {
      if (pendingRequests === 1) {
        setProgress(50);
      }
    }
    nRequests.current = pendingRequests;
  }, [pendingRequests]);

  useEffect(() => {
    clearTimeout(spinnerTimeout.current);
    if (progress > 0 && progress < 100) {
      setShowSpinner(true);
    } else {
      spinnerTimeout.current = window.setTimeout(() => {
        setShowSpinner(false);
      }, 1000);
    }
  }, [progress]);
  const marginTop = noToolName ? 'mt4' : 'mt10';
  return (
    <div className={`pl10 width-30 ${top ? 'loading-bar-spinner' : marginTop}`}>
      {showSpinner ? (
        <div className=" ml20 mt4" data-title="dot-pulse">
          <div className="stage">
            <div className="dot-pulse"></div>
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};
